import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import commonNetwork from "../../common/api/commonNetwork";
export const getIntegrationList = createAsyncThunk(
  "/Integration",
  async (parameters , { rejectWithValue }) => {
    try {

      const method = "/integration/getListByFilter";

      const { data, errorMessage, isSuccess } = await commonNetwork.get(method, parameters);

      if (isSuccess) {
        return {
          list: data.data || [], 
          totalCount: data.totalCount || 0,
          currentPage: data.currentPage || 1,
          isSyncOrders: parameters.isSync
        };
      } else {
        return rejectWithValue(errorMessage);
      }
    } catch (e) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const IntegrationSlice = createSlice({
  name: "Integration",
  initialState: {
    isloadingIntegration: false,
    integrationKey: "",
    issuccessIntegration: false,
    integrationError: "",
    integrationList: [],
    totalCount: 0,
    totalRecords: 0,
    currentPage: 1,
    isFetching: true,
    isSuccess: true,
    isError: false,
    isSyncOrders: false,
    integrationResults: []
  },
  reducers: {
    changeIntegrationLoading: (state, action) => {

      state.isloadingIntegration = action.payload;
      return state;
    },
    onIntegrationComplete: (state, action) => {
      state.integrationKey = action.payload.messageGuid;
      var results = [];
      if (action.payload.responseBody) {
        results = JSON.parse(action.payload.responseBody);
      }
      state.integrationResults = results;
      state.isloadingIntegration = false;
      return state;
    },
    updateIntegrationList: (state, action) => {
  

      state.integrationList = action.payload;
      return state;
    },
    clearIntegrationResult: (state, action) => {

      state.integrationResults = [];
      return state;
    },

  },
  extraReducers: (builder) => {
    builder.addCase(getIntegrationList.fulfilled, (state, { payload }) => {

      const data = payload.list
      state.integrationList = data;
      state.totalCount = payload.totalCount;
      state.currentPage = payload.currentPage;
      state.totalRecords = data.length;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.isSyncOrders = payload.isSyncOrders
      return state;
    });
    builder.addCase(getIntegrationList.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getIntegrationList.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { changeIntegrationLoading, onIntegrationComplete, clearIntegrationResult, updateIntegrationList } = IntegrationSlice.actions;



export const IntegrationReducer = IntegrationSlice.reducer;